// extracted by mini-css-extract-plugin
export var icon = "_qp-0";